export const claims = {
    CanCreateCoursePayment: 'CanCreateCoursePayment',
    CanUpdateCoursePayment: 'CanUpdateCoursePayment',
    CanGetCoursePayments: 'CanGetCoursePayments',

    CanCreateLateFeeConfig: 'CanCreateLateFeeConfig',
    CanUpdateLateFeeConfig: 'CanUpdateLateFeeConfig',
    CanGetLateFeeConfigies: 'CanGetLateFeeConfigies',

    CanCreatePaymentMethod: 'CanCreatePaymentMethod',
    CanUpdatePaymentMethod: 'CanUpdatePaymentMethod',
    CanGetPaymentMethods: 'CanGetPaymentMethods',

    CanCreatePaymentReference: 'CanCreatePaymentReference',
    CanUpdatePaymentReference: 'CanUpdatePaymentReference',
    CanGetPaymentReferences: 'CanGetPaymentReferences',
    CanReceiveBankPaymentReference: 'CanReceiveBankPaymentReference',
    CanGenerateReferenceCodes: 'CanGenerateReferenceCodes',
    CanUploadPaymentFile: 'CanUploadPaymentFile',

    CanCreatePaymentTransaction: 'CanCreatePaymentTransaction',
    CanUpdatePaymentTransaction: 'CanUpdatePaymentTransaction',
    CanGetPaymentTransactions: 'CanGetPaymentTransactions',

    CanCreatePaymentType: 'CanCreatePaymentType',
    CanUpdatePaymentType: 'CanUpdatePaymentType',
    CanGetPaymentTypies: 'CanGetPaymentTypies',
    CanGetPaymentTypies_Student: 'CanGetPaymentTypies_Student',

    CanGetActiveDebts: 'CanGetActiveDebts',
    CanGetDebtsByPeriod: 'CanGetDebtsByPeriod',
    CanGetOverdueDebts: 'CanGetOverdueDebts',
    CanGetDebtDistributionByPaymentType: 'CanGetDebtDistributionByPaymentType',
    CanGetPaymentsHistoryByStudent: 'CanGetPaymentsHistoryByStudent',
    CanGetTotalPaymentsByPeriods: 'CanGetTotalPaymentsByPeriods',
    CanGetComplianceRate: 'CanGetComplianceRate',
    CanGetTotalsLatesFees: 'CanGetTotalsLatesFees',
    CanGetStudentsWithMostDelays: 'CanGetStudentsWithMostDelays',
    CanGetPaymentsReport: 'CanGetPaymentsReport',
    CanGetPaymentReferenceStatus: 'CanGetPaymentReferenceStatus',

    CanCreateSchoolBankConfig: 'CanCreateSchoolBankConfig',
    CanUpdateSchoolBankConfig: 'CanUpdateSchoolBankConfig',
    CanGetSchoolBankConfigs: 'CanGetSchoolBankConfigs',
    CanGetSchoolBankConfigs_Student: 'CanGetSchoolBankConfigs_Student',

    CanCreateProcessModel: 'CanCreateProcessModel',
    CanUpdateProcessModel: 'CanUpdateProcessModel',
    CanGetProcessModels: 'CanGetProcessModels',

    CanCreateStudentDebt: 'CanCreateStudentDebt',
    CanCreateStudentDebt_Student: 'CanCreateStudentDebt_Student',
    CanUpdateStudentDebt: 'CanUpdateStudentDebt',
    CanGetStudentDebties: 'CanGetStudentDebties',
    CanGetStudentDebties_Student: 'CanGetStudentDebties_Student',
    CanGetStudentDebtiesTotal: 'CanGetStudentDebtiesTotal',
    CanGetStudentDebtiesByEnrollments: 'CanGetStudentDebtiesByEnrollments',
    CanGetStudentDebtiesBySubscriptions: 'CanGetStudentDebtiesBySubscriptions',
    CanDelStudentDebt: 'CanDelStudentDebt',

    CanCreateStudentDebtNotification: 'CanCreateStudentDebtNotification',
    CanUpdateStudentDebtNotification: 'CanUpdateStudentDebtNotification',
    CanGetStudentDebtNotifications: 'CanGetStudentDebtNotifications',

    CanCreateAcademicLevel: 'CanCreateAcademicLevel',
    CanUpdateAcademicLevel: 'CanUpdateAcademicLevel',
    CanGetAcademicLevels: 'CanGetAcademicLevels',

    CanCreateAcademicPeriod: 'CanCreateAcademicPeriod',
    CanUpdateAcademicPeriod: 'CanUpdateAcademicPeriod',
    CanDisableAcademicPeriod: 'CanDisableAcademicPeriod',
    CanGetAcademicPeriods: 'CanGetAcademicPeriods',

    CanCreateAcademicYear: 'CanCreateAcademicYear',
    CanUpdateAcademicYear: 'CanUpdateAcademicYear',
    CanGetCurrentAcademicYear: 'CanGetCurrentAcademicYear',
    CanGetCurrentAcademicYear_Teacher: 'CanGetCurrentAcademicYear_Teacher',
    CanDisableCurrentAcademicYear: 'CanDisableCurrentAcademicYear',
    CanGetAcademicYears: 'CanGetAcademicYears',

    CanCreateAssessment: 'CanCreateAssessment',
    CanCreateGeneralAssessment: 'CanCreateGeneralAssessment',
    CanUpdateAssessment: 'CanUpdateAssessment',
    CanDeleteAssessment: 'CanDeleteAssessment',
    CanGetAssessments: 'CanGetAssessments',
    CanGetAssessments_Teacher: 'CanGetAssessments_Teacher',
    CanGetMyAssessments: 'CanGetMyAssessments',

    CanCreateAuthor: 'CanCreateAuthor',
    CanUpdateAuthor: 'CanUpdateAuthor',
    CanGetAuthors: 'CanGetAuthors',

    CanCreateBlockedMember: 'CanCreateBlockedMember',
    CanUpdateBlockedMember: 'CanUpdateBlockedMember',
    CanGetBlockedMembers: 'CanGetBlockedMembers',

    CanCreateBookAuthor: 'CanCreateBookAuthor',
    CanUpdateBookAuthor: 'CanUpdateBookAuthor',
    CanGetBookAuthors: 'CanGetBookAuthors',

    CanCreateBook: 'CanCreateBook',
    CanUpdateBook: 'CanUpdateBook',
    CanGetBooks: 'CanGetBooks',

    CanCreateCategory: 'CanCreateCategory',
    CanUpdateCategory: 'CanUpdateCategory',
    CanGetCategories: 'CanGetCategories',

    CanCreateClass: 'CanCreateClass',
    CanUpdateClass: 'CanUpdateClass',
    CanDeleteClass: 'CanDeleteClass',
    CanGetClasses: 'CanGetClasses',

    CanCreateClassroom: 'CanCreateClassroom',
    CanUpdateClassroom: 'CanUpdateClassroom',
    CanDeleteClassroom: 'CanDeleteClassroom',
    CanGetClassrooms: 'CanGetClassrooms',

    CanCreateClassroomType: 'CanCreateClassroomType',
    CanUpdateClassroomType: 'CanUpdateClassroomType',
    CanGetClassroomTypes: 'CanGetClassroomTypes',

    CanCreateClassSubjectTeacher: 'CanCreateClassSubjectTeacher',
    CanUpdateClassSubjectTeacher: 'CanUpdateClassSubjectTeacher',
    CanGetClassSubjectTeachers: 'CanGetClassSubjectTeachers',

    CanCreateCoursePlan: 'CanCreateCoursePlan',
    CanUpdateCoursePlan: 'CanUpdateCoursePlan',
    CanGetCoursePlan: 'CanGetCoursePlan',
    CanGetCoursePlan_Teacher: 'CanGetCoursePlan_Teacher',

    CanCreateCourse: 'CanCreateCourse',
    CanUpdateCourse: 'CanUpdateCourse',
    CanGetCourses: 'CanGetCourses',
    CanDeleteCourse: 'CanDeleteCourse',

    CanCreateCoursesSubject: 'CanCreateCoursesSubject',
    CanUpdateCoursesSubject: 'CanUpdateCoursesSubject',
    CanRemoveSubjectsFromCourse: 'CanRemoveSubjectsFromCourse',
    CanGetCoursesSubjects: 'CanGetCoursesSubjects',

    CanCreateDepartment: 'CanCreateDepartment',
    CanUpdateDepartment: 'CanUpdateDepartment',
    CanDeleteDepartment: 'CanDeleteDepartment',
    CanGetDepartments: 'CanGetDepartments',
    CanGetDepartamentsByIdsCourses: 'CanGetDepartamentsByIdsCourses',

    CanCreateEnrollment: 'CanCreateEnrollment',
    CanUpdateEnrollment: 'CanUpdateEnrollment',
    CanDeleteEnrollment: 'CanDeleteEnrollment',
    CanGetEnrollments: 'CanGetEnrollments',
    CanGetStudentStatisticsEnrollments: 'CanGetStudentStatisticsEnrollments',

    CanCreateEnrollmentDocument: 'CanCreateEnrollmentDocument',
    CanUpdateEnrollmentDocument: 'CanUpdateEnrollmentDocument',
    CanGetEnrollmentDocuments: 'CanGetEnrollmentDocuments',
    CanDeleteEnrollmentDocument: 'CanDeleteEnrollmentDocument',

    CanCreateEnrollmentRequiredDocument: 'CanCreateEnrollmentRequiredDocument',
    CanUpdateEnrollmentRequiredDocument: 'CanUpdateEnrollmentRequiredDocument',
    CanGetEnrollmentRequiredDocuments: 'CanGetEnrollmentRequiredDocuments',

    CanCreateFaculty: 'CanCreateFaculty',
    CanUpdateFaculty: 'CanUpdateFaculty',
    CanGetFaculties: 'CanGetFaculties',

    CanCreateFormationArea: 'CanCreateFormationArea',
    CanUpdateFormationArea: 'CanUpdateFormationArea',
    CanGetFormationAreas: 'CanGetFormationAreas',

    CanCreateKnowledgeDomain: 'CanCreateKnowledgeDomain',
    CanUpdateKnowledgeDomain: 'CanUpdateKnowledgeDomain',
    CanDeleteKnowledgeDomain: 'CanDeleteKnowledgeDomain',
    CanGetKnowledgeDomains: 'CanGetKnowledgeDomains',

    CanCreateKnowledgeSubDomain: 'CanCreateKnowledgeSubDomain',
    CanUpdateKnowledgeSubDomain: 'CanUpdateKnowledgeSubDomain',
    CanGetKnowledgeSubDomains: 'CanGetKnowledgeSubDomains',

    CanCreateLessonPlanDocument: 'CanCreateLessonPlanDocument',
    CanUpdateLessonPlanDocument: 'CanUpdateLessonPlanDocument',
    CanDeleteLessonPlanDocument: 'CanDeleteLessonPlanDocument',
    CanGetLessonPlanDocuments: 'CanGetLessonPlanDocuments',

    CanCreateLessonPlan: 'CanCreateLessonPlan',
    CanUpdateLessonPlan: 'CanUpdateLessonPlan',
    CanGetLessonPlans: 'CanGetLessonPlans',
    CanGetLessonPlans_Teacher: 'CanGetLessonPlans_Teacher',

    CanGetLibraryStats: 'CanGetLibraryStats',

    CanCreateLoan: 'CanCreateLoan',
    CanUpdateLoan: 'CanUpdateLoan',
    CanGetLoans: 'CanGetLoans',

    CanCreateManager: 'CanCreateManager',
    CanUpdateManager: 'CanUpdateManager',
    CanGetManagers: 'CanGetManagers',
    CanGetManagers_Teacher: 'CanGetManagers_Teacher',
    CanGetManagers_Student: 'CanGetManagers_Student',

    CanCreatePlanSubject: 'CanCreatePlanSubject',
    CanUpdatePlanSubject: 'CanUpdatePlanSubject',
    CanRemoveSubjectsFromPlan: 'CanRemoveSubjectsFromPlan',
    CanGetPlanSubject: 'CanGetPlanSubject',
    CanGetPlanSubject_Student: 'CanGetPlanSubject_Student',

    CanCreateReservation: 'CanCreateReservation',
    CanUpdateReservation: 'CanUpdateReservation',
    CanGetReservations: 'CanGetReservations',

    CanCreateReservationStatus: 'CanCreateReservationStatus',
    CanUpdateReservationStatus: 'CanUpdateReservationStatus',
    CanGetReservationStatuses: 'CanGetReservationStatuses',

    CanCreateRetake: 'CanCreateRetake',
    CanUpdateRetake: 'CanUpdateRetake',
    CanDeleteRetake: 'CanDeleteRetake',
    CanGetRetakes: 'CanGetRetakes',

    CanCreateRulesTeacherDocument: 'CanCreateRulesTeacherDocument',
    CanUpdateRulesTeacherDocument: 'CanUpdateRulesTeacherDocument',
    CanGetRulesTeacherDocuments: 'CanGetRulesTeacherDocuments',

    CanCreateScholarshipProvider: 'CanCreateScholarshipProvider',
    CanUpdateScholarshipProvider: 'CanUpdateScholarshipProvider',
    CanGetScholarshipProviders: 'CanGetScholarshipProviders',

    CanCreateScholarship: 'CanCreateScholarship',
    CanUpdateScholarship: 'CanUpdateScholarship',
    CanGetScholarships: 'CanGetScholarships',

    CanCreateScholarshipType: 'CanCreateScholarshipType',
    CanUpdateScholarshipType: 'CanUpdateScholarshipType',
    CanGetScholarshipTypes: 'CanGetScholarshipTypes',

    CanCreateSchoolSchedule: 'CanCreateSchoolSchedule',
    CanUpdateSchoolSchedule: 'CanUpdateSchoolSchedule',
    CanDeleteSchoolSchedule: 'CanDeleteSchoolSchedule',
    CanGetSchoolSchedules: 'CanGetSchoolSchedules',
    CanGetMySchoolSchedules: 'CanGetMySchoolSchedules',

    CanCreateScientificArea: 'CanCreateScientificArea',
    CanUpdateScientificArea: 'CanUpdateScientificArea',
    CanDeleteScientificArea: 'CanDeleteScientificArea',
    CanGetByIdScientificArea: 'CanGetByIdScientificArea',
    CanGetScientificAreas: 'CanGetScientificAreas',

    CanCreateStudentAssessment: 'CanCreateStudentAssessment',
    CanUpdateStudentAssessment: 'CanUpdateStudentAssessment',
    CanBlockOrUnblockStudentAssessment: 'CanBlockOrUnblockStudentAssessment',
    CanDeleteStudentAssessment: 'CanDeleteStudentAssessment',
    CanGetStudentAssessments: 'CanGetStudentAssessments',
    CanGetStudentAssessments_Teacher: 'CanGetStudentAssessments_Teacher',
    CanGetMyStudentAssessments: 'CanGetMyStudentAssessments',

    CanCreateStudentClass: 'CanCreateStudentClass',
    CanUpdateStudentClass: 'CanUpdateStudentClass',
    CanDeleteStudentClass: 'CanDeleteStudentClass',
    CanGetStudentClasses: 'CanGetStudentClasses',
    CanGetStudentClasses_Student: 'CanGetStudentClasses_Student',

    CanCreateStudentDocument: 'CanCreateStudentDocument',
    CanCreateStudentDocument_Student: 'CanCreateStudentDocument_Student',
    CanUpdateStudentDocument: 'CanUpdateStudentDocument',
    CanGetStudentDocuments: 'CanGetStudentDocuments',
    CanGetStudentDocuments_Student: 'CanGetStudentDocuments_Student',

    CanCreateStudent: 'CanCreateStudent',
    CanUpdateStudent: 'CanUpdateStudent',
    CanGetStudents: 'CanGetStudents',
    CanGetStudentByCode: 'CanGetStudentByCode',
    CanCreateStudentUniversalCode: 'CanCreateStudentUniversalCode',
    CanGetStudentById: 'CanGetStudentById',
    CanGetStudentsSubscribedSubjects: 'CanGetStudentsSubscribedSubjects',

    CanCreateStudentSituation: 'CanCreateStudentSituation',
    CanUpdateStudentSituation: 'CanUpdateStudentSituation',
    CanGetStudentSituations: 'CanGetStudentSituations',

    CanCreateStudentSubjectGrade: 'CanCreateStudentSubjectGrade',
    CanUpdateStudentSubjectGrade: 'CanUpdateStudentSubjectGrade',
    CanGetStudentSubjectGrade: 'CanGetStudentSubjectGrade',

    CanCreateSubjectPlan: 'CanCreateSubjectPlan',
    CanUpdateSubjectPlan: 'CanUpdateSubjectPlan',
    CanGetSubjectPlans: 'CanGetSubjectPlans',

    CanCreateSubject: 'CanCreateSubject',
    CanUpdateSubject: 'CanUpdateSubject',
    CanDeleteSubject: 'CanDeleteSubject',
    CanGetSubjects: 'CanGetSubjects',
    CanGetStudentReprovedSubjects: 'CanGetStudentReprovedSubjects',
    CanGetStudentApprovedSubjects: 'CanGetStudentApprovedSubjects',

    CanCreateSubscription: 'CanCreateSubscription',
    CanCreateSubscription_Student: 'CanCreateSubscription_Student',
    CanCreateMySubscription: 'CanCreateMySubscription',
    CanUpdateSubscription: 'CanUpdateSubscription',
    CanGetSubscriptions: 'CanGetSubscriptions',
    CanDeleteSubscription: 'CanDeleteSubscription',
    CanGetSubscriptionStatistics: 'CanGetSubscriptionStatistics',
    CanGetSubscriptionStatisticsByCourse: 'CanGetSubscriptionStatisticsByCourse',
    CanGetSubscriptionsByIDStudent: 'CanGetSubscriptionsByIDStudent',

    CanCreateSubscriptionSubject: 'CanCreateSubscriptionSubject',
    CanUpdateSubscriptionSubject: 'CanUpdateSubscriptionSubject',
    CanGetSubscriptionSubjects: 'CanGetSubscriptionSubjects',
    CanGetSubscriptionByIdEnrolment: 'CanGetSubscriptionByIdEnrolment',

    CanCreateTeacherDocument: 'CanCreateTeacherDocument',
    CanUpdateTeacherDocument: 'CanUpdateTeacherDocument',
    CanGetTeacherDocuments: 'CanGetTeacherDocuments',

    CanCreateTeacherEvaluationCriteria: 'CanCreateTeacherEvaluationCriteria',
    CanUpdateTeacherEvaluationCriteria: 'CanUpdateTeacherEvaluationCriteria',
    CanGetTeacherEvaluationCriterias: 'CanGetTeacherEvaluationCriterias',
    CanGetTeacherEvaluationCriterias_Student: 'CanGetTeacherEvaluationCriterias_Student',

    CanCreateTeacherEvaluation: 'CanCreateTeacherEvaluation',
    CanUpdateTeacherEvaluation: 'CanUpdateTeacherEvaluation',
    CanGetTeacherEvaluations: 'CanGetTeacherEvaluations',

    CanCreateTeacherEvaluationsCriteria: 'CanCreateTeacherEvaluationsCriteria',
    CanUpdateTeacherEvaluationsCriteria: 'CanUpdateTeacherEvaluationsCriteria',
    CanGetTeacherEvaluationsCriterias: 'CanGetTeacherEvaluationsCriterias',
    CanGetTeacherEvaluationsCriteriaReport: 'CanGetTeacherEvaluationsCriteriaReport',

    CanCreateTeacher: 'CanCreateTeacher',
    CanUpdateTeacher: 'CanUpdateTeacher',
    CanGetTeachers: 'CanGetTeachers',
    CanCreateTeacherUniversalCode: 'CanCreateTeacherUniversalCode',
    CanGetTeacherOrStudentByUserId: 'CanGetTeacherOrStudentByUserId',
    CanGetTeacherClasses: 'CanGetTeacherClasses',
    CanGetTeacherClasses_Teacher: 'CanGetTeacherClasses_Teacher',
    CanGetTeacherSubjectsByTeacherAndClass: 'CanGetTeacherSubjectsByTeacherAndClass',

    CanCreateTeachersDepartament: 'CanCreateTeachersDepartament',
    CanUpdateTeachersDepartament: 'CanUpdateTeachersDepartament',
    CanGetTeachersDepartaments: 'CanGetTeachersDepartaments',

    CanCreateUniversity: 'CanCreateUniversity',
    CanUpdateUniversity: 'CanUpdateUniversity',
    CanGetUniversities: 'CanGetUniversities',
    CanGetUniversitiesByFacultiesIds: 'CanGetUniversitiesByFacultiesIds',

    CanCreateVacancy: 'CanCreateVacancy',
    CanUpdateVacancy: 'CanUpdateVacancy',
    CanDeleteVacancy: 'CanDeleteVacancy',
    CanGetVacancies: 'CanGetVacancies',

    CanCreateCta: 'CanCreateCta',
    CanUpdateCta: 'CanUpdateCta',  
    CanDeleteCta: 'CanDeleteCta',  
    CanGetCtas: 'CanGetCtas',  

    CanCreateEntity: 'CanCreateEntity',
    CanUpdateEntity: 'CanUpdateEntity',
    CanGetEntities: 'CanGetEntities',

    CanCreateEntitiesProject: 'CanCreateEntitiesProject',
    CanUpdateEntitiesProject: 'CanUpdateEntitiesProject',
    CanGetEntitiesProject: 'CanGetEntitiesProject',

    CanCreateExhibitor: 'CanCreateExhibitor',
    CanUpdateExhibitor: 'CanUpdateExhibitor',
    CanGetExhibitors: 'CanGetExhibitors',
    CanGetJudgeAndExhibitorByUserId: 'CanGetJudgeAndExhibitorByUserId',

    CanCreateExhibitorsProject: 'CanCreateExhibitorsProject',
    CanUpdateExhibitorsProject: 'CanUpdateExhibitorsProject',
    CanGetExhibitorsProjects: 'CanGetExhibitorsProjects',

    CanCreateJudge: 'CanCreateJudge',
    CanUpdateJudge: 'CanUpdateJudge',
    CanGetJudges: 'CanGetJudges',

    CanCreateJudgesPhasesProject: 'CanCreateJudgesPhasesProject',
    CanUpdateJudgesPhasesProject: 'CanUpdateJudgesPhasesProject',
    CanGetJudgesPhasesProjects: 'CanGetJudgesPhasesProjects',
    CanGetProjectsAssignedByIdJudge: 'CanGetProjectsAssignedByIdJudge',

    CanCreateJudgesPhasesProjectsDocument: 'CanCreateJudgesPhasesProjectsDocument',
    CanUpdateJudgesPhasesProjectsDocument: 'CanUpdateJudgesPhasesProjectsDocument',
    CanGetJudgesPhasesProjectsDocuments: 'CanGetJudgesPhasesProjectsDocuments',
    CanGetJudgePhaseProjectDocumentByIdProject: 'CanGetJudgePhaseProjectDocumentByIdProject',

    CanCreatePhase: 'CanCreatePhase',
    CanUpdatePhase: 'CanUpdatePhase',
    CanGetPhases: 'CanGetPhases',

    CanCreateProjectDocument: 'CanCreateProjectDocument',
    CanUpdateProjectDocument: 'CanUpdateProjectDocument',
    CanGetProjectDocuments: 'CanGetProjectDocuments',

    CanCreateProjectExpense: 'CanCreateProjectExpense',
    CanUpdateProjectExpense: 'CanUpdateProjectExpense',
    CanGetProjectExpenses: 'CanGetProjectExpenses',

    CanCreateProject: 'CanCreateProject',
    CanUpdateProject: 'CanUpdateProject',
    CanGetProjects: 'CanGetProjects',

    CanCreateProjectType: 'CanCreateProjectType',
    CanUpdateProjectType: 'CanUpdateProjectType',
    CanGetProjectTypes: 'CanGetProjectTypes',

    CanCreateScientific: 'CanCreateScientific',
    CanUpdateScientific: 'CanUpdateScientific',
    CanGetScientifics: 'CanGetScientifics',

    CanCreateSubEntity: 'CanCreateSubEntity',
    CanUpdateSubEntity: 'CanUpdateSubEntity',
    CanGetSubEntities: 'CanGetSubEntities',

    CanCreateSubEntitiesProject: 'CanCreateSubEntitiesProject',
    CanUpdateSubEntitiesProject: 'CanUpdateSubEntitiesProject',
    CanGetSubEntitiesProject: 'CanGetSubEntitiesProject',

    CanChangePassword: 'CanChangePassword',
    CanChangeUserLock: 'CanChangeUserLock',
    CanResetPassword: 'CanResetPassword',
    CanSendResetPasswordEmailLink: 'CanSendResetPasswordEmailLink',
    CanNewPassword: 'CanNewPassword',
    CanLogin: 'CanLogin',

    CanGetClaims: 'CanGetClaims',

    CanCreatePasswordPolicy: 'CanCreatePasswordPolicy',
    CanUpdatePasswordPolicy: 'CanUpdatePasswordPolicy',
    CanGetPasswordPolicies: 'CanGetPasswordPolicies',

    CanCreateRole: 'CanCreateRole',
    CanGetRoles: 'CanGetRoles',
    CanGetClaimsToRole: 'CanGetClaimsToRole',
    CanAddClaimsToRole: 'CanAddClaimsToRole',
    CanRemoveRoleClaims: 'CanRemoveRoleClaims',
    CanRemoveRoleClaim: 'CanRemoveRoleClaim',
    CanResetRoleClaims: 'CanResetRoleClaims',
    CanRemoveRole: 'CanRemoveRole',
    CanUpdateRole: 'CanUpdateRole',

    CanCreateUser: 'CanCreateUser',
    CanGetUsernameSuggestion: 'CanGetUsernameSuggestion',
    CanGetUsersWithPagination: 'CanGetUsersWithPagination',
    CanGetUserById: 'CanGetUserById',
    CanUpdateUser: 'CanUpdateUser',
    CanAddClaimsToUser: 'CanAddClaimsToUser',
    CanGetUserClaims: 'CanGetUserClaims',
    CanGetUserRoles: 'CanGetUserRoles',
    CanGetUserByNuit: 'CanGetUserByNuit',
    CanGetUserByBi: 'CanGetUserByBi',
    CanRemoveUserClaims: 'CanRemoveUserClaims',
    CanRemoveUserRole: 'CanRemoveUserRole',
    CanAddUserRole: 'CanAddUserRole',

    CanCreateSettings : "CanCreateSettings",
    CanUpdateSettings : "CanUpdateSettings",
    CanDeleteSettings : "CanDeleteSettings",
    CanGetSettings : "CanGetSettings",

    HaveBills: 'HaveBills',
} as const;


export const translations = {
    CanCreateCoursePayment: 'Pode criar pagamento de curso',
    CanUpdateCoursePayment: 'Pode atualizar pagamento de curso',
    CanGetCoursePayments: 'Pode obter pagamentos de cursos',

    CanCreateLateFeeConfig: 'Pode criar configuração de multa por atraso',
    CanUpdateLateFeeConfig: 'Pode atualizar configuração de multa por atraso',
    CanGetLateFeeConfigies: 'Pode obter configurações de multas por atraso',

    CanCreatePaymentMethod: 'Pode criar método de pagamento',
    CanUpdatePaymentMethod: 'Pode atualizar método de pagamento',
    CanGetPaymentMethods: 'Pode obter métodos de pagamento',

    CanCreatePaymentReference: 'Pode criar referência de pagamento',
    CanUpdatePaymentReference: 'Pode atualizar referência de pagamento',
    CanGetPaymentReferences: 'Pode obter referências de pagamento',
    CanReceiveBankPaymentReference: 'Pode receber referência bancária de pagamento',
    CanGenerateReferenceCodes: 'Pode gerar códigos de referência',
    CanUploadPaymentFile: 'Pode carregar ficheiro de pagamento',

    CanCreatePaymentTransaction: 'Pode criar transação de pagamento',
    CanUpdatePaymentTransaction: 'Pode atualizar transação de pagamento',
    CanGetPaymentTransactions: 'Pode obter transações de pagamento',

    CanCreatePaymentType: 'Pode criar Tipo de emolumento',
    CanUpdatePaymentType: 'Pode atualizar Tipo de emolumento',
    CanGetPaymentTypies: 'Pode obter tipos de pagamento',
    CanGetPaymentTypies_Student: 'Pode obter tipos de pagamento - Estudante',

    CanGetActiveDebts: 'Pode obter dívidas ativas',
    CanGetDebtsByPeriod: 'Pode obter dívidas por período',
    CanGetOverdueDebts: 'Pode obter dívidas vencidas',
    CanGetDebtDistributionByPaymentType: 'Pode obter distribuição de dívidas por Tipo de emolumento',
    CanGetPaymentsHistoryByStudent: 'Pode obter histórico de pagamentos por estudante',
    CanGetTotalPaymentsByPeriods: 'Pode obter totais de pagamentos por períodos',
    CanGetComplianceRate: 'Pode obter taxa de conformidade',
    CanGetTotalsLatesFees: 'Pode obter totais de multas por atraso',
    CanGetStudentsWithMostDelays: 'Pode obter estudantes com mais atrasos',
    CanGetPaymentsReport: 'Pode obter relatório de pagamentos',
    CanGetPaymentReferenceStatus: 'Pode obter estado da referência de pagamento',

    CanCreateSchoolBankConfig: 'Pode criar configuração bancária da escola',
    CanUpdateSchoolBankConfig: 'Pode atualizar configuração bancária da escola',
    CanGetSchoolBankConfigs: 'Pode obter configurações bancárias da escola',
    CanGetSchoolBankConfigs_Student: 'Pode obter configurações bancárias da escola - Estudante',

    CanCreateProcessModel: 'Pode criar modelo de processo',
    CanUpdateProcessModel: 'Pode atualizar modelo de processo',
    CanGetProcessModels: 'Pode obter modelos de processo',

    CanCreateStudentDebt: 'Pode criar dívida de estudante',
    CanCreateStudentDebt_Student: 'Pode criar dívida de estudante - Estudante',
    CanUpdateStudentDebt: 'Pode atualizar dívida de estudante',
    CanGetStudentDebties: 'Pode obter dívidas de estudantes',
    CanGetStudentDebties_Student: 'Pode obter dívidas de estudantes - Estudante',
    CanGetStudentDebtiesTotal: 'Pode obter total de dívidas de estudantes',
    CanGetStudentDebtiesByEnrollments: 'Pode obter dívidas de estudantes por matrículas',
    CanGetStudentDebtiesBySubscriptions: 'Pode obter dívidas de estudantes por inscrições',
    CanDelStudentDebt: 'Pode eliminar dívida de estudante',

    CanCreateStudentDebtNotification: 'Pode criar notificação de dívida de estudante',
    CanUpdateStudentDebtNotification: 'Pode atualizar notificação de dívida de estudante',
    CanGetStudentDebtNotifications: 'Pode obter notificações de dívida de estudante',

    CanCreateAcademicLevel: 'Pode criar nível académico',
    CanUpdateAcademicLevel: 'Pode atualizar nível académico',
    CanGetAcademicLevels: 'Pode obter níveis académicos',

    CanCreateAcademicPeriod: 'Pode criar período académico',
    CanUpdateAcademicPeriod: 'Pode atualizar período académico',
    CanDisableAcademicPeriod: 'Pode desativar período académico',
    CanGetAcademicPeriods: 'Pode obter períodos académicos',

    CanCreateAcademicYear: 'Pode criar ano académico',
    CanUpdateAcademicYear: 'Pode atualizar ano académico',
    CanGetCurrentAcademicYear: 'Pode obter ano académico atual',
    CanGetCurrentAcademicYear_Teacher: 'Pode obter ano académico atual - Docente',
    CanDisableCurrentAcademicYear: 'Pode desativar ano académico atual',
    CanGetAcademicYears: 'Pode obter anos académicos',

    CanCreateAssessment: 'Pode criar avaliação',
    CanCreateGeneralAssessment: 'Pode criar avaliação geral',
    CanUpdateAssessment: 'Pode atualizar avaliação',
    CanDeleteAssessment: 'Pode eliminar avaliação',
    CanGetAssessments: 'Pode obter avaliações',
    CanGetAssessments_Teacher: 'Pode obter avaliações - Docente',
    CanGetMyAssessments: 'Pode obter as minhas avaliações',

    CanCreateAuthor: 'Pode criar autor',
    CanUpdateAuthor: 'Pode atualizar autor',
    CanGetAuthors: 'Pode obter autores',

    CanCreateBlockedMember: 'Pode criar membro bloqueado',
    CanUpdateBlockedMember: 'Pode atualizar membro bloqueado',
    CanGetBlockedMembers: 'Pode obter membros bloqueados',

    CanCreateBookAuthor: 'Pode criar autor de livro',
    CanUpdateBookAuthor: 'Pode atualizar autor de livro',
    CanGetBookAuthors: 'Pode obter autores de livros',

    CanCreateBook: 'Pode criar livro',
    CanUpdateBook: 'Pode atualizar livro',
    CanGetBooks: 'Pode obter livros',

    CanCreateCategory: 'Pode criar categoria',
    CanUpdateCategory: 'Pode atualizar categoria',
    CanGetCategories: 'Pode obter categorias',

    CanCreateClass: 'Pode criar turma',
    CanUpdateClass: 'Pode atualizar turma',
    CanDeleteClass: 'Pode eliminar turma',
    CanGetClasses: 'Pode obter turmas',

    CanCreateClassroom: 'Pode criar sala de aula',
    CanUpdateClassroom: 'Pode atualizar sala de aula',
    CanDeleteClassroom: 'Pode eliminar sala de aula',
    CanGetClassrooms: 'Pode obter salas de aula',

    CanCreateClassroomType: 'Pode criar tipo de sala de aula',
    CanUpdateClassroomType: 'Pode atualizar tipo de sala de aula',
    CanGetClassroomTypes: 'Pode obter tipos de salas de aula',

    CanCreateClassSubjectTeacher: 'Pode vincular turma e disciplina ao docente',
    CanUpdateClassSubjectTeacher: 'Pode atualizar vinculo turma e disciplina ao docente',
    CanGetClassSubjectTeachers: 'Pode obter vinculos de turma e disciplina ao docente',

    CanCreateCoursePlan: 'Pode criar plano de curso',
    CanUpdateCoursePlan: 'Pode atualizar plano de curso',
    CanGetCoursePlan: 'Pode obter plano de curso',
    CanGetCoursePlan_Teacher: 'Pode obter plano de curso - Docente',

    CanCreateCourse: 'Pode criar curso',
    CanUpdateCourse: 'Pode atualizar curso',
    CanGetCourses: 'Pode obter cursos',
    CanDeleteCourse: 'Pode eliminar curso',

    CanCreateCoursesSubject: 'Pode criar disciplina de curso',
    CanUpdateCoursesSubject: 'Pode atualizar disciplina de curso',
    CanRemoveSubjectsFromCourse: 'Pode remover disciplinas de curso',
    CanGetCoursesSubjects: 'Pode obter disciplinas de cursos',

    CanCreateDepartment: 'Pode criar departamento',
    CanUpdateDepartment: 'Pode atualizar departamento',
    CanDeleteDepartment: 'Pode eliminar departamento',
    CanGetDepartments: 'Pode obter departamentos',
    CanGetDepartamentsByIdsCourses: 'Pode obter departamentos por IDs de cursos',

    CanCreateEnrollment: 'Pode criar matrícula',
    CanUpdateEnrollment: 'Pode atualizar matrícula',
    CanDeleteEnrollment: 'Pode eliminar matrícula',
    CanGetEnrollments: 'Pode obter matrículas',
    CanGetStudentStatisticsEnrollments: 'Pode obter estatísticas de matrículas de estudantes',

    CanCreateEnrollmentDocument: 'Pode criar documento de matrícula',
    CanUpdateEnrollmentDocument: 'Pode atualizar documento de matrícula',
    CanGetEnrollmentDocuments: 'Pode obter documentos de matrícula',
    CanDeleteEnrollmentDocument: 'Pode eliminar documento de matrícula',

    CanCreateEnrollmentRequiredDocument: 'Pode criar documento obrigatório de matrícula',
    CanUpdateEnrollmentRequiredDocument: 'Pode atualizar documento obrigatório de matrícula',
    CanGetEnrollmentRequiredDocuments: 'Pode obter documentos obrigatórios de matrícula',

    CanCreateFaculty: 'Pode criar faculdade',
    CanUpdateFaculty: 'Pode atualizar faculdade',
    CanGetFaculties: 'Pode obter faculdades',

    CanCreateFormationArea: 'Pode criar área de formação',
    CanUpdateFormationArea: 'Pode atualizar área de formação',
    CanGetFormationAreas: 'Pode obter áreas de formação',

    CanCreateKnowledgeDomain: 'Pode criar domínio de conhecimento',
    CanUpdateKnowledgeDomain: 'Pode atualizar domínio de conhecimento',
    CanDeleteKnowledgeDomain: 'Pode eliminar domínio de conhecimento',
    CanGetKnowledgeDomains: 'Pode obter domínios de conhecimento',

    CanCreateKnowledgeSubDomain: 'Pode criar subdomínio de conhecimento',
    CanUpdateKnowledgeSubDomain: 'Pode atualizar subdomínio de conhecimento',
    CanGetKnowledgeSubDomains: 'Pode obter subdomínios de conhecimento',

    CanCreateLessonPlanDocument: 'Pode criar documento de plano de aula',
    CanUpdateLessonPlanDocument: 'Pode atualizar documento de plano de aula',
    CanDeleteLessonPlanDocument: 'Pode eliminar documento de plano de aula',
    CanGetLessonPlanDocuments: 'Pode obter documentos de planos de aula',

    CanCreateLessonPlan: 'Pode criar plano de aula',
    CanUpdateLessonPlan: 'Pode atualizar plano de aula',
    CanGetLessonPlans: 'Pode obter planos de aula',
    CanGetLessonPlans_Teacher: 'Pode obter planos de aula - Docente',

    CanGetLibraryStats: 'Pode obter estatísticas da biblioteca',

    CanCreateLoan: 'Pode criar empréstimo',
    CanUpdateLoan: 'Pode atualizar empréstimo',
    CanGetLoans: 'Pode obter empréstimos',

    CanCreateManager: 'Pode criar gestor',
    CanUpdateManager: 'Pode atualizar gestor',
    CanGetManagers: 'Pode obter gestores',
    CanGetManagers_Teacher: 'Pode obter gestores - Docente',
    CanGetManagers_Student: 'Pode obter gestores - Estudante',

    CanCreatePlanSubject: 'Pode criar disciplina de plano',
    CanUpdatePlanSubject: 'Pode atualizar disciplina de plano',
    CanRemoveSubjectsFromPlan: 'Pode remover disciplinas de plano',
    CanGetPlanSubject: 'Pode obter disciplina de plano',
    CanGetPlanSubject_Student: 'Pode obter disciplina de plano - Estudante',

    CanCreateReservation: 'Pode criar reserva',
    CanUpdateReservation: 'Pode atualizar reserva',
    CanGetReservations: 'Pode obter reservas',

    CanCreateReservationStatus: 'Pode criar estado de reserva',
    CanUpdateReservationStatus: 'Pode atualizar estado de reserva',
    CanGetReservationStatuses: 'Pode obter estados de reserva',

    CanCreateRetake: 'Pode criar recuperação',
    CanUpdateRetake: 'Pode atualizar recuperação',
    CanDeleteRetake: 'Pode eliminar recuperação',
    CanGetRetakes: 'Pode obter recuperações',

    CanCreateRulesTeacherDocument: 'Pode criar documento de regras do docente',
    CanUpdateRulesTeacherDocument: 'Pode atualizar documento de regras do docente',
    CanGetRulesTeacherDocuments: 'Pode obter documentos de regras do docente',

    CanCreateScholarshipProvider: 'Pode criar bolseiro',
    CanUpdateScholarshipProvider: 'Pode atualizar bolseiro',
    CanGetScholarshipProviders: 'Pode obter bolseiros',

    CanCreateScholarship: 'Pode criar bolsa',
    CanUpdateScholarship: 'Pode atualizar bolsa',
    CanGetScholarships: 'Pode obter bolsas',

    CanCreateScholarshipType: 'Pode criar tipo de bolsa',
    CanUpdateScholarshipType: 'Pode atualizar tipo de bolsa',
    CanGetScholarshipTypes: 'Pode obter tipos de bolsa',

    CanCreateSchoolSchedule: 'Pode criar horário escolar',
    CanUpdateSchoolSchedule: 'Pode atualizar horário escolar',
    CanDeleteSchoolSchedule: 'Pode eliminar horário escolar',
    CanGetSchoolSchedules: 'Pode obter horários escolares',
    CanGetMySchoolSchedules: 'Pode obter os meus horários escolares',

    CanCreateScientificArea: 'Pode criar área científica',
    CanUpdateScientificArea: 'Pode atualizar área científica',
    CanDeleteScientificArea: 'Pode eliminar área científica',
    CanGetByIdScientificArea: 'Pode obter área científica por ID',
    CanGetScientificAreas: 'Pode obter áreas científicas',

    CanCreateStudentAssessment: 'Pode criar avaliação de estudante',
    CanUpdateStudentAssessment: 'Pode atualizar avaliação de estudante',
    CanBlockOrUnblockStudentAssessment: 'Pode bloquear ou desbloquear avaliação de estudante',
    CanDeleteStudentAssessment: 'Pode eliminar avaliação de estudante',
    CanGetStudentAssessments: 'Pode ver notas das avaliações de estudantes',
    CanGetStudentAssessments_Teacher: 'Pode obter avaliações de estudantes - Docente',
    CanGetMyStudentAssessments: 'Pode obter as minhas avaliações de estudante',

    CanCreateStudentClass: 'Pode adicionar estudantes a turma',
    CanUpdateStudentClass: 'Pode atualizar estudantes da estudante',
    CanDeleteStudentClass: 'Pode eliminar estudante da turma',
    CanGetStudentClasses: 'Pode obter estudantes da turma',
    CanGetStudentClasses_Student: 'Pode obter turmas de estudantes - Estudante',

    CanCreateStudentDocument: 'Pode fazer pedido de documentos de estudante',
    CanCreateStudentDocument_Student: 'Pode criar documento de estudante - Estudante',
    CanUpdateStudentDocument: 'Pode atualizar documento de estudante',
    CanGetStudentDocuments: 'Pode obter pedidos de documentos dos estudantes',
    CanGetStudentDocuments_Student: 'Pode obter documentos de estudantes - Estudante',

    CanCreateStudent: 'Pode criar estudante',
    CanUpdateStudent: 'Pode atualizar estudante',
    CanGetStudents: 'Pode obter estudantes',
    CanGetStudentByCode: 'Pode obter estudante por código',
    CanCreateStudentUniversalCode: 'Pode criar código universal de estudante',
    CanGetStudentById: 'Pode obter estudante por ID',
    CanGetStudentsSubscribedSubjects: 'Pode obter disciplinas inscritas por estudantes',

    CanCreateStudentSituation: 'Pode criar situação de estudante',
    CanUpdateStudentSituation: 'Pode atualizar situação de estudante',
    CanGetStudentSituations: 'Pode obter situações de estudantes',

    CanCreateStudentSubjectGrade: 'Pode criar nota de disciplina de estudante',
    CanUpdateStudentSubjectGrade: 'Pode atualizar nota de disciplina de estudante',
    CanGetStudentSubjectGrade: 'Pode obter notas de disciplinas de estudantes',

    CanCreateSubjectPlan: 'Pode criar plano de disciplina',
    CanUpdateSubjectPlan: 'Pode atualizar plano de disciplina',
    CanGetSubjectPlans: 'Pode obter planos de disciplinas',

    CanCreateSubject: 'Pode criar disciplina',
    CanUpdateSubject: 'Pode atualizar disciplina',
    CanDeleteSubject: 'Pode eliminar disciplina',
    CanGetSubjects: 'Pode obter disciplinas',
    CanGetStudentReprovedSubjects: 'Pode obter disciplinas reprovadas de estudante',
    CanGetStudentApprovedSubjects: 'Pode obter disciplinas aprovadas de estudante',

    CanCreateSubscription: 'Pode criar inscrição',
    CanCreateSubscription_Student: 'Pode criar inscrição - Estudante',
    CanCreateMySubscription: 'Pode criar minha inscrição',
    CanUpdateSubscription: 'Pode atualizar inscrição',
    CanGetSubscriptions: 'Pode obter inscrições',
    CanDeleteSubscription: 'Pode eliminar inscrição',
    CanGetSubscriptionStatistics: 'Pode obter estatísticas de inscrições',
    CanGetSubscriptionStatisticsByCourse: 'Pode obter estatísticas de inscrições por curso',
    CanGetSubscriptionsByIDStudent: 'Pode obter inscrições por ID de estudante',

    CanCreateSubscriptionSubject: 'Pode criar disciplina de inscrição',
    CanUpdateSubscriptionSubject: 'Pode atualizar disciplina de inscrição',
    CanGetSubscriptionSubjects: 'Pode obter disciplinas de inscrição',
    CanGetSubscriptionByIdEnrolment: 'Pode obter inscrição por ID de matrícula',

    CanCreateTeacherDocument: 'Pode criar documento de docente',
    CanUpdateTeacherDocument: 'Pode atualizar documento de docente',
    CanGetTeacherDocuments: 'Pode obter documentos de docente',

    CanCreateTeacherEvaluationCriteria: 'Pode criar critério de avaliação de docente',
    CanUpdateTeacherEvaluationCriteria: 'Pode atualizar critério de avaliação de docente',
    CanGetTeacherEvaluationCriterias: 'Pode obter critérios de avaliação de docente',
    CanGetTeacherEvaluationCriterias_Student: 'Pode obter critérios de avaliação de docente - Estudante',

    CanCreateTeacherEvaluation: 'Pode criar avaliação de docente',
    CanUpdateTeacherEvaluation: 'Pode atualizar avaliação de docente',
    CanGetTeacherEvaluations: 'Pode obter avaliações de docente',

    CanCreateTeacherEvaluationsCriteria: 'Pode criar critérios de avaliação de docente',
    CanUpdateTeacherEvaluationsCriteria: 'Pode atualizar critérios de avaliação de docente',
    CanGetTeacherEvaluationsCriterias: 'Pode obter critérios de avaliação de docente',
    CanGetTeacherEvaluationsCriteriaReport: 'Pode obter relatório de critérios de avaliação de docente',

    CanCreateTeacher: 'Pode criar docente',
    CanUpdateTeacher: 'Pode atualizar docente',
    CanGetTeachers: 'Pode obter docente',
    CanCreateTeacherUniversalCode: 'Pode criar código universal de docente',
    CanGetTeacherOrStudentByUserId: 'Pode obter docente ou estudante por ID de utilizador',
    CanGetTeacherClasses: 'Pode obter turmas de docente',
    CanGetTeacherClasses_Teacher: 'Pode obter turmas de docente - Docente',
    CanGetTeacherSubjectsByTeacherAndClass: 'Pode obter disciplinas de docente por docente e turma',

    CanCreateTeachersDepartament: 'Pode criar departamento de docente',
    CanUpdateTeachersDepartament: 'Pode atualizar departamento de docente',
    CanGetTeachersDepartaments: 'Pode obter departamentos de docente',

    CanCreateUniversity: 'Pode criar universidade',
    CanUpdateUniversity: 'Pode atualizar universidade',
    CanGetUniversities: 'Pode obter universidades',
    CanGetUniversitiesByFacultiesIds: 'Pode obter universidades por IDs de faculdades',

    CanCreateVacancy: 'Pode criar vaga',
    CanUpdateVacancy: 'Pode atualizar vaga',
    CanDeleteVacancy: 'Pode eliminar vaga',
    CanGetVacancies: 'Pode obter vagas',

    CanCreateCta: 'Pode criar cta',
    CanUpdateCta: 'Pode atualizar cta',  
    CanDeleteCta: 'Pode eliminar cta',
    CanGetCtas: 'Pode obter ctas',

    CanCreateEntity: 'Pode criar entidade',
    CanUpdateEntity: 'Pode atualizar entidade',
    CanGetEntities: 'Pode obter entidades',

    CanCreateEntitiesProject: 'Pode criar projeto de entidades',
    CanUpdateEntitiesProject: 'Pode atualizar projeto de entidades',
    CanGetEntitiesProject: 'Pode obter projetos de entidades',

    CanCreateExhibitor: 'Pode criar expositor',
    CanUpdateExhibitor: 'Pode atualizar expositor',
    CanGetExhibitors: 'Pode obter expositores',
    CanGetJudgeAndExhibitorByUserId: 'Pode obter júri ou expositor por ID de utilizador',

    CanCreateExhibitorsProject: 'Pode criar projeto de expositores',
    CanUpdateExhibitorsProject: 'Pode atualizar projeto de expositores',
    CanGetExhibitorsProjects: 'Pode obter projetos de expositores',

    CanCreateJudge: 'Pode criar júri',
    CanUpdateJudge: 'Pode atualizar júri',
    CanGetJudges: 'Pode obter júris',

    CanCreateJudgesPhasesProject: 'Pode criar fase de projeto de júris',
    CanUpdateJudgesPhasesProject: 'Pode atualizar fase de projeto de júris',
    CanGetJudgesPhasesProjects: 'Pode obter fases de projetos de júris',
    CanGetProjectsAssignedByIdJudge: 'Pode obter projetos atribuídos por ID de júri',

    CanCreateJudgesPhasesProjectsDocument: 'Pode criar documento de fase de projeto de júris',
    CanUpdateJudgesPhasesProjectsDocument: 'Pode atualizar documento de fase de projeto de júris',
    CanGetJudgesPhasesProjectsDocuments: 'Pode obter documentos de fases de projetos de júris',
    CanGetJudgePhaseProjectDocumentByIdProject: 'Pode obter documento de fase de projeto de júri por ID de projeto',

    CanCreatePhase: 'Pode criar fase',
    CanUpdatePhase: 'Pode atualizar fase',
    CanGetPhases: 'Pode obter fases',

    CanCreateProjectDocument: 'Pode criar documento de projeto',
    CanUpdateProjectDocument: 'Pode atualizar documento de projeto',
    CanGetProjectDocuments: 'Pode obter documentos de projeto',

    CanCreateProjectExpense: 'Pode criar despesa de projeto',
    CanUpdateProjectExpense: 'Pode atualizar despesa de projeto',
    CanGetProjectExpenses: 'Pode obter despesas de projeto',

    CanCreateProject: 'Pode criar projeto',
    CanUpdateProject: 'Pode atualizar projeto',
    CanGetProjects: 'Pode obter projetos',

    CanCreateProjectType: 'Pode criar tipo de projeto',
    CanUpdateProjectType: 'Pode atualizar tipo de projeto',
    CanGetProjectTypes: 'Pode obter tipos de projeto',

    CanCreateScientific: 'Pode criar científico',
    CanUpdateScientific: 'Pode atualizar científico',
    CanGetScientifics: 'Pode obter científicos',

    CanCreateSubEntity: 'Pode criar subentidade',
    CanUpdateSubEntity: 'Pode atualizar subentidade',
    CanGetSubEntities: 'Pode obter subentidades',

    CanCreateSubEntitiesProject: 'Pode criar projeto de subentidades',
    CanUpdateSubEntitiesProject: 'Pode atualizar projeto de subentidades',
    CanGetSubEntitiesProject: 'Pode obter projetos de subentidades',

    CanChangePassword: 'Pode alterar palavra-passe',
    CanChangeUserLock: 'Pode alterar bloqueio de utilizador',
    CanResetPassword: 'Pode redefinir palavra-passe',
    CanSendResetPasswordEmailLink: 'Pode enviar link de redefinição de palavra-passe por email',
    CanNewPassword: 'Pode definir nova palavra-passe',
    CanLogin: 'Pode iniciar sessão',

    CanGetClaims: 'Pode obter permissões',

    CanCreatePasswordPolicy: 'Pode criar política de palavra-passe',
    CanUpdatePasswordPolicy: 'Pode atualizar política de palavra-passe',
    CanGetPasswordPolicies: 'Pode obter políticas de palavra-passe',

    CanCreateRole: 'Pode criar função',
    CanGetRoles: 'Pode obter funções',
    CanGetClaimsToRole: 'Pode obter permissões para função',
    CanAddClaimsToRole: 'Pode adicionar permissões a função',
    CanRemoveRoleClaims: 'Pode remover permissões de função',
    CanRemoveRoleClaim: 'Pode remover permissão de função',
    CanResetRoleClaims: 'Pode redefinir permissões de função',
    CanRemoveRole: 'Pode remover função',
    CanUpdateRole: 'Pode atualizar função',

    CanCreateUser: 'Pode criar utilizador',
    CanGetUsernameSuggestion: 'Pode obter sugestão de nome de utilizador',
    CanGetUsersWithPagination: 'Pode obter utilizadores com paginação', 
    CanGetUserById: 'Pode obter utilizador por ID', 
    CanUpdateUser: 'Pode atualizar utilizador', 
    CanAddClaimsToUser: 'Pode adicionar permissões a utilizador', 
    CanGetUserClaims: 'Pode obter permissões de utilizador',
    CanGetUserRoles: 'Pode obter funções de utilizador',
    CanGetUserByNuit: 'Pode obter utilizador por NUIT',
    CanGetUserByBi: 'Pode obter utilizador por BI',
    CanRemoveUserClaims: 'Pode remover permissões de utilizador',
    CanRemoveUserRole: 'Pode remover função de utilizador',
    CanAddUserRole: 'Pode adicionar função a utilizador',

   CanCreateSettings: 'Pode criar definições do sistema',
   CanUpdateSettings: 'Pode atualizar definições do sistema',
   CanDeleteSettings: 'Pode apagar definições do sistema',
   CanGetSettings: 'Pode obter definições do sistema',



    HaveBills: 'Tem dívidas',
} as const;